import { Can } from 'providers/casl'
import { onAbTestsAccess } from '../features/abTests'
import { onAdUnitAccess } from '../features/adUnit'
import {
  onDomainAccess,
  onDomainCreateUpdateDelete,
  onDomainOverridenByYieldbirdRead,
  onDomainRichPlacementsMultiAnchorAccess,
} from '../features/domain'
import { onFinanceAccess } from '../features/finance'
import { onGlobalSetupAmazonAccess } from '../features/globalSetup/amazon'
import { onGlobalSetupAccess, onGlobalSetupWorkspaceUserACUD } from '../features/globalSetup/common'
import {
  onGlobalSetupDefaultsPrebidStackAccess,
  onGlobalSetupDefaultsRichPlacementsAccess,
} from '../features/globalSetup/defaults'
import { onGlobalSetupGoogleAdManagerConnectionAccess } from '../features/globalSetup/googleAccountManagerConnection'
import {
  onGlobalSetupBiddersBidParamsOwnUpdate,
  onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate,
  onGlobalSetupPrebidBiddersAccess,
  onGlobalSetupPrebidModuleAccess,
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead,
  onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead,
  onGlobalSetupPrebidProtectionAccess,
} from '../features/globalSetup/prebid'
import { onGlobalSetupSupplyChainAccess } from '../features/globalSetup/supplyChain'
import { onViewportCUD } from '../features/globalSetup/viewport'
import { onHistoryAccess } from '../features/history'
import {
  onGamAccountSidebarItemAccess,
  onHelpMenuItemAccess,
  onLayoutAccess,
} from '../features/layout'
import { onPageAccess, onPageCreateUpdateDelete } from '../features/page'
import { onPerformanceAllProductAccess, onPerformanceGeneralAccess } from '../features/performance'
import { onPortalAccess } from '../features/portal'
import { onProductAccess } from '../features/product'
import { onTagAccess } from '../features/tag'
import { onUserPagePublisherACUD } from '../features/user'

export const onCustomerSuccess = (can: Can) => {
  onAbTestsAccess(can)
  onAdUnitAccess(can)
  onDomainAccess(can)
  onDomainCreateUpdateDelete(can)
  onDomainOverridenByYieldbirdRead(can)
  onDomainRichPlacementsMultiAnchorAccess(can)
  onFinanceAccess(can)
  onGamAccountSidebarItemAccess(can)
  onGlobalSetupAccess(can)
  onGlobalSetupAmazonAccess(can)
  onGlobalSetupBiddersBidParamsOwnUpdate(can)
  onGlobalSetupBiddersBidParamsThirdPartyProviderUpdate(can)
  onGlobalSetupDefaultsPrebidStackAccess(can)
  onGlobalSetupDefaultsRichPlacementsAccess(can)
  onGlobalSetupGoogleAdManagerConnectionAccess(can)
  onGlobalSetupPrebidBiddersAccess(can)
  onGlobalSetupPrebidModuleAccess(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsOwnRead(can)
  onGlobalSetupPrebidModulesInventoryConnectionParamsYieldbirdRead(can)
  onGlobalSetupPrebidProtectionAccess(can)
  onGlobalSetupSupplyChainAccess(can)
  onGlobalSetupWorkspaceUserACUD(can)
  onHelpMenuItemAccess(can)
  onHistoryAccess(can)
  onLayoutAccess(can)
  onPageAccess(can)
  onPageCreateUpdateDelete(can)
  onPerformanceAllProductAccess(can)
  onPerformanceGeneralAccess(can)
  onPortalAccess(can)
  onProductAccess(can)
  onTagAccess(can)
  onUserPagePublisherACUD(can)
  onViewportCUD(can)
}
